/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useSelector } from 'react-redux';

import { getOfferInboxData } from '../../../state/ducks/App/App-Selectors';
import { getProfileInfo, getUserEmailId } from '../../../state/ducks/Member/ducks/Common/Common-Selectors';
import useExperience from './useExperience';

const useOfferInboxPopup = ({
    interactionName,
    targeting = {},
    type = 'content',
    apolloOptions = {},
    resolveIdentity = false,
    queryName = 'OfferInboxPopup',
    featureFlag = true,
    isSessionHasAccount = false,
}) => {
    const offerInbox = useSelector(getOfferInboxData);
    const userInfo = useSelector(getProfileInfo);
    const emailId = useSelector(getUserEmailId);

    const userIdentity = {};
    if (offerInbox?.email || emailId) {
        userIdentity.emailId = offerInbox?.email || emailId;
    }
    if (offerInbox?.phone) {
        userIdentity.phone = offerInbox?.phone;
    }

    let sessionOGOptIn = `${offerInbox?.offerGatewayOptin}`;
    let sessionOGLoggedIn = 'false';
    let sessionOGAccountCreation = 'false';

    if (userInfo?.offerGatewayOptin) {
        sessionOGOptIn = `${userInfo.offerGatewayOptin === 'true'}`;
        sessionOGLoggedIn = `${userInfo?.loginsCount > 1}`;
        sessionOGAccountCreation = `${userInfo?.loginsCount === 1}`;
    }

    const ogUserAttributes = [
        { name: 'sessionOGOptIn', value: sessionOGOptIn },
        { name: 'sessionOGLoggedIn', value: sessionOGLoggedIn },
        { name: 'sessionOGAccountCreation', value: sessionOGAccountCreation },
        { name: 'sessionOGOptInSMS', value: `${offerInbox?.offerGatewayOptinSMS}` },
        { name: 'sessionOGOfferUnlockSMS', value: `${offerInbox?.offerUnlockedSMS}` },
    ];

    if (isSessionHasAccount) {
        ogUserAttributes.push({ name: 'hasAccountCookie', value: 'true' });
    }

    return useExperience({
        interactionName,
        targeting,
        userAttributes: ogUserAttributes,
        type,
        apolloOptions,
        resolveIdentity,
        queryName,
        featureFlag,
        userInfo: userIdentity,
    });
};

export default useOfferInboxPopup;
